import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CheckoutButton } from './CheckoutButton';
import { CountdownTimer } from './CountdownTimer';
import { checkoutUrl, productImage } from '../data/content';
export function PricingCard() {
  return <section id="pricing" className="scroll-mt-0 bg-brand-navy px-4 py-5 text-white sm:px-6" aria-labelledby="offer-heading" data-id="element-124" data-mp="1m6dtmwe2pww0">
      <div className="mb-3 text-center" data-id="element-125" data-mp="2et8bdljiai5s">
        <p className="mb-1 text-[11px] font-extrabold uppercase tracking-widest text-brand-green sm:text-xs" data-id="element-126" data-mp="2es6z5dqr7pmh">
          Offre spéciale — Système complet 6-en-1
        </p>
        <h2 id="offer-heading" className="mb-1 font-heading text-xl uppercase leading-tight sm:text-3xl" data-id="element-127" data-mp="25240oy0v5jgr">
          PADEL COACH READY™
        </h2>
        <p className="mb-2 text-[12px] font-bold sm:text-sm" data-id="element-128" data-mp="20zr2cuog4nu0">
          Accédez dès aujourd&apos;hui au système qui transformera votre façon de préparer vos
          entraînements. Le Système Complet de Planification 6-en-1 pour les Coachs de Padel.
        </p>
        <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block focus:outline-none focus:ring-2 focus:ring-brand-green" data-id="element-129" data-mp="32kuecih1hwuv">
          <img src={productImage} alt="PADEL COACH READY™ — système complet 6-en-1" className="mx-auto w-full max-w-[240px] object-contain drop-shadow-[0_16px_36px_rgba(0,0,0,0.5)] transition-transform duration-200 hover:scale-[1.02]" data-id="element-130" data-mp="2stra57std1rd" />
        </a>
      </div>
      <div className="mx-auto max-w-md rounded-xl border-2 border-brand-green bg-white p-3.5 text-center text-brand-ink shadow-2xl" data-id="element-131" data-mp="2ouiiq9l8xfyz">
        <ul className="mb-2 space-y-0.5 text-[12px] font-bold text-brand-navy sm:text-sm" data-id="element-132" data-mp="29y167f1blvau">
          <li data-id="element-133" data-mp="2ewkwfrmy5t90">✅ 6 Modules Professionnels</li>
          <li data-id="element-134" data-mp="841wgy3ujm09">✅ 5 Bonus Premium</li>
        </ul>
        <p className="text-[12px] font-semibold text-brand-muted" data-id="element-135" data-mp="827b5ionxrvn">
          Prix habituel : <span className="line-through" data-id="element-136" data-mp="d2lmb9lk9hxw">97 €</span>
        </p>
        <p className="my-1 text-[12px] font-extrabold uppercase text-brand-green sm:text-sm" data-id="element-137" data-mp="bmhj41ancby0">
          🔥 Offre de lancement — 72 % de réduction
        </p>
        <p className="mb-1 font-heading text-2xl uppercase leading-none text-brand-navy sm:text-3xl" data-id="element-138" data-mp="6phd1qdsr96w">
          Aujourd&apos;hui seulement : <span className="text-brand-green" data-id="element-139" data-mp="3tschurangbm2">27 €</span>
        </p>
        <p className="mb-2 text-[10px] font-medium text-brand-muted" data-id="element-140" data-mp="3tu7203e3jzp3">
          Payez en toute sécurité dans votre devise locale.
        </p>
        <p className="mb-1 text-[11px] font-extrabold uppercase text-brand-navy sm:text-xs" data-id="element-141" data-mp="pdcoh3lxsawu">
          🔥 Cette offre disparaîtra lorsque le compteur atteindra zéro.
        </p>
        <div className="mb-2" data-id="element-142" data-mp="glkip67uxpyl">
          <CountdownTimer data-id="element-143" data-mp="gkj3cpjt6hb2" />
        </div>
        <CheckoutButton data-id="element-144" data-mp="gjhqqgn59mr8">🚀 OUI ! JE VEUX MON SYSTÈME COMPLET 6-EN-1</CheckoutButton>
        <div className="mt-2 flex flex-col items-center justify-center gap-0.5 text-[11px] font-bold text-brand-navy sm:flex-row sm:gap-3" data-id="element-145" data-mp="1d4i3xhnyt16m">
          <span data-id="element-146" data-mp="2qzrsf1bh9xaa">⭐ 4,9/5 — Avis vérifiés de coachs de padel</span>
          <span className="flex items-center gap-1" data-id="element-147" data-mp="2r1bbt0sfkoga">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-brand-green" aria-hidden="true" data-id="element-148" data-mp="2vzcrdbqne5n0" />
            Garantie 7 jours — Zéro risque
          </span>
        </div>
      </div>
    </section>;
}